import React from 'react';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Link } from '../../components/ui/Link';

const QuerySection: React.FC = () => (
  <div className="flex flex-col flex-1 px-[16px] md:px-[30px] items-center py-[16px] md:pb-[30px] lg:pt-[78px]">
    <h2 className="font-avantgarde text-center text-[18px] leading-[27px] sm:text-[22px] sm:leading-[33px]
    text-blue-900 font-bold mb-[24px]">
      Staat je vraag er niet bij?
    </h2>
    <p
      className="text-stone-800 font-roboto font-medium
   text-center sm:leading-[29.7px] leading-[23.1px]
   text:[14px] sm:text-[18px] mb-[24px]"
    >
      Stel hem via het contactformulier, je krijgt dan zo snel mogelijk een
      reactie van ons!
    </p>
    <Link
      variant="primary"
      href="/home/contact"
      className="w-full md:w-fit md:text-sm font-bold"
    >
      Naar het contactformulier
      <FontAwesomeIcon icon={faChevronRight as IconProp} />
    </Link>
  </div>
);

export default QuerySection;
